module.exports = __webpack_public_path__ + "static/media/intro-parents_png.9d17160b.png";